import "babel-polyfill";
import React, { Component } from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import Loadable from "react-loadable";

import { Home, Result, NewHome } from "./pages";

import "./App.css";
import "antd/dist/antd.css";
import "./static/style/lib/common.css";
import "./static/style/lib/reset.css";

const HomeComponent = Loadable({
  loader: () => import("./pages/home"),
  loading: Home,
});

const ResultComponent = Loadable({
  loader: () => import("./pages/result"),
  loading: Result,
});

const NewHomeComponent = Loadable({
    loader: () => import("./pages/newHome"),
    loading: NewHome
})

class App extends Component {
  componentDidMount() {}

  render() {
    return (
      <div>
        <Switch>
          {/* <Route path="/" exact component={HomeComponent}></Route> */}
          <Route path="/" exact component={NewHomeComponent}></Route>
          <Route path="/result" component={ResultComponent}></Route>
          <Redirect to={{ pathname: "/" }} />
        </Switch>
      </div>
    );
  }
}

export default withRouter(App);
